"use client";
import Image from "next/image";

export default function MasonryGrid() {
  return (
    <main className="masonry-grid-container">
      <div className="masonry-grid-item-1">
        <Image
          width={1000}
          height={1000}
          className="masonry-grid-img"
          src="https://media.thespeechclinic.ae/website/images/gallery/beckman%20stretches.jpg"
          alt="Beckman stretches therapy session"
          priority
          quality={75}
        />
      </div>
      <div className="masonry-grid-item-2">
        <Image
          width={1000}
          height={1000}
          className="masonry-grid-img"
          src="https://media.thespeechclinic.ae/website/images/aba/sce-02.jpg"
          alt="ABA therapy session"
          quality={75}
        />
      </div>
      <div className="masonry-grid-item-3">
        <Image
          width={1000}
          height={1000}
          className="masonry-grid-img"
          src="https://media.thespeechclinic.ae/website/images/aba/aba-03.jpg"
          alt="ABA therapy activities"
          quality={75}
        />
      </div>
      <div className="masonry-grid-item-4">
        <Image
          width={1500}
          height={1500}
          className="masonry-grid-img"
          src="https://media.thespeechclinic.ae/website/images/aba/aba-01.jpg"
          alt="ABA therapy session"
          quality={75}
        />
      </div>
      <div className="masonry-grid-item-5">
        <Image
          width={1500}
          height={1500}
          className="masonry-grid-img"
          src="https://media.thespeechclinic.ae/website/images/occupational-therapy/adl/adl%202.jpg"
          alt="Activities of daily living therapy"
          quality={75}
        />
      </div>
      <div className="masonry-grid-item-6">
        <Image
          width={1500}
          height={1500}
          className="masonry-grid-img"
          src="https://media.thespeechclinic.ae/website/images/occupational-therapy/adl/SCE-188.jpg"
          alt="Activities of daily living session"
          quality={75}
        />
      </div>
      <div className="masonry-grid-item-7">
        <Image
          width={1500}
          height={1500}
          className="masonry-grid-img"
          src="https://media.thespeechclinic.ae/website/images/occupational-therapy/handwriting/OLIVE%20MEDIA%20UAE-6693.jpg"
          alt="Handwriting therapy session"
          quality={75}
        />
      </div>
      <div className="masonry-grid-item-8">
        <Image
          width={1500}
          height={1500}
          className="masonry-grid-img"
          src="https://media.thespeechclinic.ae/website/images/occupational-therapy/interactive-metronome/INTERACTIVE%20METRONEME.JPG"
          alt="Interactive metronome therapy"
          quality={75}
        />
      </div>
      <div className="masonry-grid-item-9">
        <Image
          width={1500}
          height={1500}
          className="masonry-grid-img"
          src="https://media.thespeechclinic.ae/website/images/occupational-therapy/play-therapy/LOS%20SM%20CAMPAIGN-85%20(1).jpg"
          alt="Play therapy session"
          quality={75}
        />
      </div>
      <div className="masonry-grid-item-10">
        <Image
          width={1500}
          height={1500}
          className="masonry-grid-img"
          src="https://media.thespeechclinic.ae/website/images/occupational-therapy/play-therapy/play%20therapy%203.jpg"
          alt="Play therapy activities"
          quality={75}
        />
      </div>
      <div className="masonry-grid-item-11">
        <Image
          width={1500}
          height={1500}
          className="masonry-grid-img"
          src="https://media.thespeechclinic.ae/website/images/occupational-therapy/play-therapy/play%20therapy%204.jpg"
          alt="Play therapy session"
          quality={75}
        />
      </div>
      <div className="masonry-grid-item-12">
        <Image
          width={1500}
          height={1500}
          className="masonry-grid-img"
          src="https://media.thespeechclinic.ae/website/images/occupational-therapy/SENSORY%20INTEGRATION/SCE-33.jpg"
          alt="Sensory integration therapy"
          quality={75}
        />
      </div>
      <div className="masonry-grid-item-13">
        <Image
          width={1500}
          height={1500}
          className="masonry-grid-img"
          src="https://media.thespeechclinic.ae/website/images/occupational-therapy/SENSORY%20INTEGRATION/SCE-34.jpg"
          alt="Sensory integration activities"
          quality={75}
        />
      </div>
      <div className="masonry-grid-item-14">
        <Image
          width={1500}
          height={1500}
          className="masonry-grid-img"
          src="https://media.thespeechclinic.ae/website/images/occupational-therapy/SENSORY%20INTEGRATION/OT%203.jpg"
          alt="Occupational therapy session"
          quality={75}
        />
      </div>
      <div className="masonry-grid-item-15">
        <Image
          width={1500}
          height={1500}
          className="masonry-grid-img"
          src="https://media.thespeechclinic.ae/website/images/occupational-therapy/visual-motor-integration/OLIVE%20MEDIA%20UAE-6282.jpg"
          alt="Visual motor integration therapy"
          quality={75}
        />
      </div>
    </main>
  );
}
